import { useState } from "react";

const useToggle = (initialValue = false) => {
    const [isToggled, setIsToggled] = useState(initialValue);
    const toggle = (value) => setIsToggled(typeof value === 'boolean' ? value : !isToggled);
    return { isToggled, toggle };
};

export default useToggle;
